export default "__VITE_ASSET__HUudazzX__"